import React, { useEffect, useRef, useState } from 'react'
import Main from '../../Main'
import { Col, Row } from 'react-bootstrap'
import '../../../assets/css/dashboard.scss'
import totalCustomer from '../../../assets/images/Dashboard/total-customer-img.svg'
import activeInactive from '../../../assets/images/Dashboard/total-active-inactive-img.svg'
import customerUnderValidity from '../../../assets/images/Dashboard/total-customer-under-validity.svg'
import customerLicenseExperation from '../../../assets/images/Dashboard/customer-licence-expiration.svg'
import Download from '../../MainSection/Download/Download'
import BarChart from '../../Graphs/BarChart'
import RelationshipTypeChart from '../../Graphs/RelationshipTypeChart'
import FunnelChart from '../../Graphs/FunnelChart'
import LicenceSpliteUpChart from '../../Graphs/LicenceSpliteUpChart'
import CustomerStatusChart from '../../Graphs/CustomerStatusChart'
import AssignedModules from '../../Graphs/AssignedModules'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loadCustomerDashboardCardData } from '../../../redux/action'
import Skeleton from 'react-loading-skeleton';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import loader from '../../../../src/assets/images/Dashboard/loader.gif'

function DashBoard() {
    let dispatch = useDispatch();

    const { getCustomerDashboardCardData = [] } = useSelector((state) => state.data);
    const { customViews = [] } = useSelector((state) => state.data);

    const [loading, setLoading] = useState(true);
    const [selectedDashboardID, setSelectedDashboardID] = useState(null);

    useEffect(() => {
        dispatch(loadCustomerDashboardCardData(null, setLoading));
    }, [])

    const labels = ['Active', 'Inactive', 'New'];
    const colors = [
        'rgba(58, 201, 119, 1)', // Active
        'rgba(255, 94, 94, 1)',  // Inactive
        'rgba(255, 159, 0, 1)'  // New
    ];
    const data = [25, 20, 13];

    const Rlabels = ['Headquarter', 'Business Unit', 'Branch Office', 'Storage Location'];
    const Rcolors = [
        'rgba(58, 201, 119, 1)', // Headquarter
        'rgba(255, 94, 94, 1)',  // Business Unit
        'rgba(255, 159, 0, 1)',  // Branch Office
        'rgba(52, 58, 64, 1)',  // Storage Location
    ];
    const Rdata = [25, 20, 13, 30];

    const funnelColors = ['rgba(0, 133, 163, 1)', 'rgba(3, 170, 207, 1)', 'rgba(6, 201, 244, 1)'];
    const funnelLabels = ['LC Available', 'LC Used', 'LC Provider'];
    const funnelData = [
        { value: 200 },
        { value: 150 },
        { value: 100 },
    ];
    const navigate = useNavigate();
    const handleDashboardLibraryClick = () => {
        navigate('/dashboard-library')
    }
    const handleBack = () => {
        const moduleId = 2;
        navigate('/customermanagement', { state: { moduleId } })
    };

    const handleNavigation = () => {
        navigate('/customermanagement')
    }

    // Default state for the number of days (between 0 and 30)
    const [daysRemaining, setDaysRemaining] = useState(30);

    // Handler for changing the range slider value
    const handleSliderChange = (event) => {
        const newDays = parseInt(event.target.value, 10); // Update daysRemaining with slider value
        setDaysRemaining(newDays);

        // Pass the updated LicenseExpiryDays value to the API (only for the License Expiration card)
        dispatch(loadCustomerDashboardCardData(newDays, setLoading));  // Passing the new daysRemaining value to the API call
    };

    const barChartRef = useRef(null);
    const licenceSpliteUpRef = useRef(null);
    const NoofLicenceFunnelRef = useRef(null);
    const customerStatusChartRef = useRef(null);
    const relationShipTypeChartRef = useRef(null);

    const handleDownloadExcel = () => {
        barChartRef.current.handleDownloadExcel();
        licenceSpliteUpRef.current.handleDownloadExcel();
        NoofLicenceFunnelRef.current.handleDownloadExcel();
        customerStatusChartRef.current.handleDownloadExcel();
        relationShipTypeChartRef.current.handleDownloadExcel();
    }

    const handleDownloadPDF = () => {
        // Call BarChart's handleDownloadPDF method here
        barChartRef.current.handleDownloadPDF();
        licenceSpliteUpRef.current.handleDownloadPDF();
        NoofLicenceFunnelRef.current.handleDownloadPDF();
        customerStatusChartRef.current.handleDownloadPDF();
        relationShipTypeChartRef.current.handleDownloadPDF();
    };
    const handleDownloadWord = () => {
        // Call BarChart's handleDownloadPDF method here
        barChartRef.current.handleDownloadWord();
        licenceSpliteUpRef.current.handleDownloadWord();
        NoofLicenceFunnelRef.current.handleDownloadWord();
        customerStatusChartRef.current.handleDownloadWord();
        relationShipTypeChartRef.current.handleDownloadWord();
    };
    // const handlePrint = () => {
    //     // Call BarChart's handleDownloadPDF method here
    //     // Ensure refs are correctly set before calling print
    //     if (barChartRef.current && licenceSpliteUpRef.current && NoofLicenceFunnelRef.current && customerStatusChartRef.current && relationShipTypeChartRef.current) {
    //         barChartRef.current.handlePrint();
    //         licenceSpliteUpRef.current.handlePrint();
    //         NoofLicenceFunnelRef.current.handlePrint();
    //         customerStatusChartRef.current.handlePrint();
    //         relationShipTypeChartRef.current.handlePrint();
    //     } else {
    //         console.error('One or more refs are not initialized.');
    //     }
    // };

    const handlePrint = async () => {
        let printableContent = '<html><head><title>Print Charts</title></head><body>';

        const refs = [
            barChartRef.current,
            licenceSpliteUpRef.current,
            NoofLicenceFunnelRef.current,
            customerStatusChartRef.current,
            relationShipTypeChartRef.current
        ];

        for (const ref of refs) {
            if (ref && ref.handleDownloadImage) {
                try {
                    const imageSrc = await ref.handleDownloadImage(); // Get image URL
                    if (imageSrc) {
                        printableContent += `<img src="${imageSrc}" style="width:100%; margin-bottom: 20px;" />`;
                    }
                } catch (error) {
                    console.error(`Error getting image from chart:`, error);
                }
            } else {
                console.error('One or more refs are not initialized or missing handleDownloadImage.');
            }
        }

        printableContent += '</body></html>';

        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(printableContent);
            printWindow.document.close();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        } else {
            console.error("Popup blocked. Please allow popups for this site.");
        }
    };

    // const handlePrint = async () => {
    //     if (!barChartRef.current || !licenceSpliteUpRef.current || !NoofLicenceFunnelRef.current) {
    //         console.error("One or more refs are not initialized.");
    //         return;
    //     }

    //     const printSteps = [
    //         () => barChartRef.current.handlePrint(),
    //         () => licenceSpliteUpRef.current.handlePrint(),
    //         () => NoofLicenceFunnelRef.current.handlePrint(),
    //     ];

    //     let currentStep = 0;

    //     const proceedToNextPrint = () => {
    //         if (currentStep < printSteps.length) {
    //             setTimeout(() => {
    //                 printSteps[currentStep++]();
    //             }, 2000); // Delay of 2 seconds to allow printing before opening next
    //         }
    //     };

    //     // Start the first print
    //     proceedToNextPrint();

    //     // Listen for when print is completed and move to the next
    //     window.onafterprint = () => {
    //         proceedToNextPrint();
    //     };
    // };

    const handleDownloadImage = () => {
        // Call BarChart's handleDownloadPDF method here
        barChartRef.current.handleDownloadImage();
        licenceSpliteUpRef.current.handleDownloadImage();
        NoofLicenceFunnelRef.current.handleDownloadImage();
        customerStatusChartRef.current.handleDownloadImage();
        relationShipTypeChartRef.current.handleDownloadImage();
    };

    const determineColumnSize = (visibleCols) => {
        if (visibleCols === 1) {
            return 12;  // One column takes the full width
        } else if (visibleCols === 2) {
            return 6;  // Two columns each take half the width
        } else if (visibleCols === 3) {
            return 4;  // Three columns each take a third of the width
        } else if (visibleCols >= 4) {
            return 3;  // Four or more columns each take a quarter of the width
        }
        return 4;  // Default fallback
    };

    return (
        <div className='dashboard-container'>
            <Main>
                {loading ? (
                    <div className="loading-container" style={{ position: 'absolute', top: '40%', left: '40%' }}>
                        <img src={loader} style={{ width: '180px' }} />
                    </div>
                ) : (
                    <>
                        <div className='components-download-container'>
                            <Download
                                // moduleName="Customer Dashboard"
                                moduleName={customViews?.[0]?.DashboardName || "Licence Dashboard"}
                                showBackButton={true}
                                showDashboardLibraryButton={true}
                                showSaveCustomViewButton={true}
                                showCustomViewDropdown={true}
                                showAnalyticsButton={false}
                                showDownloadDropdown={true}
                                onClick={handleDashboardLibraryClick}
                                onBackClick={handleBack}
                                // onImageClick={handleDownloadImage}
                                onExcelDownloadClick={handleDownloadExcel}
                                onPdfDownloadClick={handleDownloadPDF}
                                onWordDownloadClick={handleDownloadWord}
                                onPrintClick={handlePrint}
                                onImageClick={handleDownloadImage}
                                customViews={customViews}
                                onCustomDashboardSelect={setSelectedDashboardID}
                            />
                        </div>
                        <div>
                            {/* <Row className='dashboard-cards-container'>
                        <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                            <div className='dashboard-cards'
                            >
                                <div className='dashboard-cards-counts'>
                                    <p>Total Customer</p>
                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.TotalCompanies}</b>
                                </div>
                                <div className='dashboard-cards-image'>
                                    <img src={totalCustomer} alt="" />
                                </div>
                            </div>
                        </Col>
                        <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                            <div className='dashboard-cards'
                            >
                                <div className='dashboard-cards-counts'>
                                    <p>Active / InActive</p>
                                    <b>{loading ? <Skeleton width={100} /> : `${getCustomerDashboardCardData?.ActiveCompanies}/${getCustomerDashboardCardData?.InActiveCompanies}`}</b>
                                </div>
                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                    <img src={activeInactive} alt="" />
                                </div>
                            </div>
                        </Col>
                        <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                            <div className='dashboard-cards'
                            >
                                <div className='dashboard-cards-counts'>
                                    <p>Customer Under Validity</p>
                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.ValidCompanies}</b>
                                </div>
                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                    <img src={customerUnderValidity} alt="" />
                                </div>
                            </div>
                        </Col>

                        <Col md={3} className="p-0 dashboard-cards-cols">
                            <div className="dashboard-cards">
                                <div className="dashboard-cards-counts">
                                    <p>Customer License Expiration</p>
                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.LicenseExpiringCompanies}</b>
                                    <p className="dashboard-expiring-text">Expiring in {daysRemaining} days</p>
                                    <div className="dashboard-progress-bar">
                                        <input
                                            type="range"
                                            min="0"
                                            max="30"
                                            value={daysRemaining}
                                            onChange={handleSliderChange}
                                        />
                                    </div>
                                </div>
                                <div
                                    className="dashboard-cards-image"
                                    style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}
                                >
                                    <img
                                        src={customerLicenseExperation}
                                        alt="License Expiration Icon"
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row> */}
                            <Row className='dashboard-cards-container'>
                                { // Case 1: customViews is empty → show all cards
                                    (!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                        <>
                                            {/* Total Customer */}
                                            <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                <div className='dashboard-cards'>
                                                    <div className='dashboard-cards-counts'>
                                                        <p>Total Customer</p>
                                                        <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.TotalCompanies}</b>
                                                    </div>
                                                    <div className='dashboard-cards-image'>
                                                        <img src={totalCustomer} alt="" />
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Active / Inactive */}
                                            <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                <div className='dashboard-cards'>
                                                    <div className='dashboard-cards-counts'>
                                                        <p>Active / InActive</p>
                                                        <b>{loading ? <Skeleton width={100} /> : `${getCustomerDashboardCardData?.ActiveCompanies}/${getCustomerDashboardCardData?.InActiveCompanies}`}</b>
                                                    </div>
                                                    <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                        <img src={activeInactive} alt="" />
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Customer Under Validity */}
                                            <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                <div className='dashboard-cards'>
                                                    <div className='dashboard-cards-counts'>
                                                        <p>Customer Under Validity</p>
                                                        <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.ValidCompanies}</b>
                                                    </div>
                                                    <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                                        <img src={customerUnderValidity} alt="" />
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Customer License Expiration */}
                                            <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                <div className='dashboard-cards'>
                                                    <div className='dashboard-cards-counts'>
                                                        <p>Customer License Expiration</p>
                                                        <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.LicenseExpiringCompanies}</b>
                                                        <p className="dashboard-expiring-text">Expiring in {daysRemaining} days</p>
                                                        <div className="dashboard-progress-bar">
                                                            <input
                                                                type="range"
                                                                min="0"
                                                                max="30"
                                                                value={daysRemaining}
                                                                onChange={handleSliderChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="dashboard-cards-image" style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                                                        <img src={customerLicenseExperation} alt="License Expiration Icon" />
                                                    </div>
                                                </div>
                                            </Col>
                                        </>
                                    ) : (
                                        // Case 2: customViews is not empty → show based on GraphLibraryID
                                        customViews?.map((view, viewIndex) => {
                                            let visibleCols = 0;

                                            // Count how many graphs are visible based on conditions
                                            view.Graphs.forEach((graph) => {
                                                if (graph.GraphLibraryID === 1) visibleCols += 1;
                                                if (graph.GraphLibraryID === 2) visibleCols += 1;
                                                if (graph.GraphLibraryID === 3) visibleCols += 1;
                                                if (graph.GraphLibraryID === 4) visibleCols += 1;
                                            });

                                            const columnSize = determineColumnSize(visibleCols); // Calculate `md` value based on visible columns

                                            return view.Graphs?.map((graph, index) => {
                                                if (graph.GraphLibraryID === 1) {
                                                    return (
                                                        <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                            <div className='dashboard-cards'>
                                                                <div className='dashboard-cards-counts'>
                                                                    <p>Total Customer</p>
                                                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.TotalCompanies}</b>
                                                                </div>
                                                                <div className='dashboard-cards-image'>
                                                                    <img src={totalCustomer} alt="" />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    );
                                                }

                                                if (graph.GraphLibraryID === 2) {
                                                    return (
                                                        <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                            <div className='dashboard-cards'>
                                                                <div className='dashboard-cards-counts'>
                                                                    <p>Active / InActive</p>
                                                                    <b>{loading ? <Skeleton width={100} /> : `${getCustomerDashboardCardData?.ActiveCompanies}/${getCustomerDashboardCardData?.InActiveCompanies}`}</b>
                                                                </div>
                                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                                    <img src={activeInactive} alt="" />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    );
                                                }

                                                if (graph.GraphLibraryID === 3) {
                                                    return (
                                                        <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                            <div className='dashboard-cards'>
                                                                <div className='dashboard-cards-counts'>
                                                                    <p>Customer Under Validity</p>
                                                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.ValidCompanies}</b>
                                                                </div>
                                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                                                    <img src={customerUnderValidity} alt="" />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    );
                                                }

                                                if (graph.GraphLibraryID === 4) {
                                                    return (
                                                        <Col md={columnSize} key={index} className="p-0 pe-3 ps-1 dashboard-cards-cols">
                                                            <div className="dashboard-cards">
                                                                <div className="dashboard-cards-counts">
                                                                    <p>Customer License Expiration</p>
                                                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.LicenseExpiringCompanies}</b>
                                                                    <p className="dashboard-expiring-text">Expiring in {daysRemaining} days</p>
                                                                    <div className="dashboard-progress-bar">
                                                                        <input
                                                                            type="range"
                                                                            min="0"
                                                                            max="30"
                                                                            value={daysRemaining}
                                                                            onChange={handleSliderChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="dashboard-cards-image" style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                                                                    <img src={customerLicenseExperation} alt="License Expiration Icon" />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    );
                                                }

                                                return null; // If no matching GraphLibraryID, return nothing
                                            });
                                        })
                                    )}
                            </Row>

                            {/* <Row className='dashboard-charts'>
                        <Col xs={12} sm={12} md={6} lg={6} className='dashboard-charts-div p-0'>
                            <div className='charts-container'>
                                <BarChart
                                    moduleName="Customer Details"
                                    showTypeNameMonth={false}
                                    showYear={true}
                                    label="Customer Details"
                                    // handleDownloadPDF={handleDownloadPDF}
                                    ref={barChartRef}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={3} lg={3} className='dashboard-charts-div p-0 '>
                            <div className='charts-container'>
                                <RelationshipTypeChart
                                    moduleName="Relationship Type"
                                    labels={Rlabels}
                                    colors={Rcolors}
                                    data={Rdata}
                                    showYear={true}
                                    showCompany={true}
                                    ref={relationShipTypeChartRef}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={3} lg={3} className='dashboard-charts-div p-0 pe-4'>
                            <div style={{ height: "100%" }}>
                                <FunnelChart
                                    moduleName="No of Licence"
                                    colors={funnelColors}
                                    labels={funnelLabels}
                                    data={funnelData}
                                    ref={NoofLicenceFunnelRef}
                                />
                            </div>
                        </Col>
                    </Row> */}

                            <Row className='dashboard-charts'>
                                {/* Case 1: customViews is empty → show all cards */}
                                {(!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                    (() => {
                                        const charts = [
                                            {
                                                id: 5, component: (
                                                    <div className='charts-container  pe-2 ps-1'>
                                                        <BarChart
                                                            moduleName="Customer Details"
                                                            showTypeNameMonth={false}
                                                            showYear={true}
                                                            label="Customer Details"
                                                            ref={barChartRef}
                                                        />
                                                    </div>
                                                )
                                            },
                                            {
                                                id: 6, component: (
                                                    <div className='charts-container  pe-2 ps-1'>
                                                        <RelationshipTypeChart
                                                            moduleName="Relationship Type"
                                                            labels={Rlabels}
                                                            colors={Rcolors}
                                                            data={Rdata}
                                                            showYear={true}
                                                            showCompany={true}
                                                            ref={relationShipTypeChartRef}
                                                        />
                                                    </div>
                                                )
                                            },
                                            {
                                                id: 7, component: (
                                                    <div className='charts-container  pe-2 ps-1'>
                                                        <FunnelChart
                                                            moduleName="No of Licence"
                                                            colors={funnelColors}
                                                            labels={funnelLabels}
                                                            data={funnelData}
                                                            ref={NoofLicenceFunnelRef}
                                                        />
                                                    </div>
                                                )
                                            }
                                        ];

                                        return charts.map(({ id, component }, index) => {
                                            let colSize = 12;
                                            if (charts.length === 2) colSize = 6;
                                            if (charts.length === 3) colSize = id === 5 ? 6 : 3;

                                            return (
                                                <Col
                                                    key={id}
                                                    xs={12}
                                                    sm={12}
                                                    md={colSize}
                                                    lg={colSize}
                                                    className={`dashboard-charts-div p-0 ${id === 7 ? 'pe-1' : ''}`}
                                                >
                                                    <div className='charts-container' style={{ height: '100%' }}>
                                                        {component}
                                                    </div>
                                                </Col>
                                            );
                                        });
                                    })()
                                ) : (
                                    // Case 2: customViews is not empty → show based on GraphLibraryID
                                    customViews.map((view, viewIndex) => {
                                        const visibleGraphs = view.Graphs?.filter(graph =>
                                            [5, 6, 7].includes(graph.GraphLibraryID)
                                        ) || [];

                                        return visibleGraphs.map((graph, index) => {
                                            const id = graph.GraphLibraryID;

                                            // let colSize = 12;
                                            // if (visibleGraphs.length === 2) colSize = 6;
                                            // if (visibleGraphs.length === 3) colSize = id === 5 ? 6 : 3;

                                            let colSize = 12;
                                            if (id === 6) {
                                                colSize = 3; // Always 3 for Relationship Type
                                            } else if (visibleGraphs.length === 2) {
                                                colSize = 6;
                                            } else if (visibleGraphs.length === 3) {
                                                colSize = id === 5 ? 6 : 3;
                                            }

                                            let chartComponent = null;

                                            if (id === 5) {
                                                chartComponent = (
                                                    <div className='charts-container  pe-2 ps-1'>
                                                        <BarChart
                                                            moduleName="Customer Details"
                                                            showTypeNameMonth={false}
                                                            showYear={true}
                                                            label="Customer Details"
                                                            ref={barChartRef}
                                                        />
                                                    </div>
                                                );
                                            }

                                            if (id === 6) {
                                                chartComponent = (
                                                    <div className='charts-container  pe-2 ps-1'>
                                                        <RelationshipTypeChart
                                                            moduleName="Relationship Type"
                                                            labels={Rlabels}
                                                            colors={Rcolors}
                                                            data={Rdata}
                                                            showYear={true}
                                                            showCompany={true}
                                                            ref={relationShipTypeChartRef}
                                                        />
                                                    </div>
                                                );
                                            }

                                            if (id === 7) {
                                                chartComponent = (
                                                    <div className='charts-container  pe-2 ps-1'>
                                                        <FunnelChart
                                                            moduleName="No of Licence"
                                                            colors={funnelColors}
                                                            labels={funnelLabels}
                                                            data={funnelData}
                                                            ref={NoofLicenceFunnelRef}
                                                        />
                                                    </div>
                                                );
                                            }

                                            return (
                                                <Col
                                                    key={index}
                                                    xs={12}
                                                    sm={12}
                                                    md={colSize}
                                                    lg={colSize}
                                                    className={`dashboard-charts-div p-0 ${id === 7 ? 'pe-1' : ''}`}
                                                >
                                                    <div className='charts-container' style={{ height: '100%' }}>
                                                        {chartComponent}
                                                    </div>
                                                </Col>
                                            );
                                        });
                                    })
                                )}
                            </Row>

                            {/* <Row className='dashboard-charts pt-4 pb-4'>
                        <Col md={6} className='dashboard-charts-div p-0'>
                            <div className='charts-container'>
                                <LicenceSpliteUpChart ref={licenceSpliteUpRef} />
                            </div>
                        </Col>
                        <Col md={3} className='dashboard-charts-div p-0'>
                            <div className='charts-container'>
                                <CustomerStatusChart
                                    labels={labels}
                                    colors={colors}
                                    data={data}
                                    ref={customerStatusChartRef}
                                />
                            </div>
                        </Col>
                        <Col md={3} className='dashboard-charts-div p-0 pe-4'>
                            <AssignedModules />
                        </Col>
                    </Row> */}

                            <Row className='dashboard-charts pt-4 pb-4'>
                                {(!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                    (() => {
                                        const charts = [
                                            {
                                                id: 8,
                                                component: (
                                                    <div className='charts-container pe-2 ps-1 '>
                                                        <LicenceSpliteUpChart ref={licenceSpliteUpRef} />
                                                    </div>
                                                )
                                            },
                                            {
                                                id: 9,
                                                component: (
                                                    <div className='charts-container pe-2 ps-1 '>
                                                        <CustomerStatusChart
                                                            labels={labels}
                                                            colors={colors}
                                                            data={data}
                                                            ref={customerStatusChartRef}
                                                        />
                                                    </div>
                                                )
                                            },
                                            {
                                                id: 10,
                                                component: (
                                                    <div className='dashboard-charts-div p-0 pe-2 ps-1 '>
                                                        <AssignedModules />
                                                    </div>
                                                )
                                            }
                                        ];

                                        const count = charts.length;

                                        return charts.map(({ id, component }) => {
                                            let colSize = 12;
                                            if (count === 2) colSize = 6;
                                            if (count === 3) colSize = id === 8 ? 6 : 3;

                                            return (
                                                <Col
                                                    key={id}
                                                    xs={12}
                                                    sm={12}
                                                    md={colSize}
                                                    lg={colSize}
                                                    className='dashboard-charts-div p-0'
                                                >
                                                    <div className='charts-container' style={{ height: '100%' }}>
                                                        {component}
                                                    </div>
                                                </Col>
                                            );
                                        });
                                    })()
                                ) : (
                                    customViews.map((view, viewIndex) => {
                                        const visibleGraphs = view.Graphs?.filter(graph =>
                                            [8, 9, 10].includes(graph.GraphLibraryID)
                                        ) || [];

                                        return visibleGraphs.map((graph, index) => {
                                            const id = graph.GraphLibraryID;

                                            let colSize = 12;
                                            if (visibleGraphs.length === 2) colSize = 6;
                                            if (visibleGraphs.length === 3) colSize = id === 8 ? 6 : 3;

                                            let chartComponent = null;

                                            if (id === 8) {
                                                chartComponent = (
                                                    <div className='charts-container pe-2 ps-1'>
                                                        <LicenceSpliteUpChart ref={licenceSpliteUpRef} />
                                                    </div>
                                                );
                                            }

                                            if (id === 9) {
                                                chartComponent = (
                                                    <div className='charts-container pe-2 ps-1'>
                                                        <CustomerStatusChart
                                                            labels={labels}
                                                            colors={colors}
                                                            data={data}
                                                            ref={customerStatusChartRef}
                                                        />
                                                    </div>
                                                );
                                            }

                                            if (id === 10) {
                                                chartComponent = (
                                                    <div className='dashboard-charts-div p-0 pe-2 ps-1'>
                                                        <AssignedModules />
                                                    </div>
                                                );
                                            }

                                            return (
                                                <Col
                                                    key={index}
                                                    xs={12}
                                                    sm={12}
                                                    md={colSize}
                                                    lg={colSize}
                                                    className='dashboard-charts-div p-0'
                                                >
                                                    <div className='charts-container' style={{ height: '100%' }}>
                                                        {chartComponent}
                                                    </div>
                                                </Col>
                                            );
                                        });
                                    })
                                )}
                            </Row>
                        </div>
                    </>
                )}
            </Main>
        </div>
    )
}

export default DashBoard

